export const COMPONENT_NAME = 'SimilarSearch';
